import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITaskPatchModel } from 'src/app/models/domain/task-patch.model';

@Injectable({
  providedIn: 'root',
})
export class ProjectTaskDataService {
  public constructor(private readonly httpClient: HttpClient) {}

  public updateTask(model: ITaskPatchModel, projectGuid: string, taskGuid: string) {
    return this.httpClient.patch(`api/project/${projectGuid}/task/${taskGuid}`, model, {
      responseType: 'json',
    });
  }
}
